export const getRoute = (state) => state.voting_form.routes.get("currentRoute");

export const getModalState = (state) => state.voting_form.routes.get("isModalOpen");
